import { DialogComponent } from './dialog.js';

/** Keep Escape inside this guide when it opens above a quick-view dialog. */
class CustomSizeGuide extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('keydown', this.stopEscapePropagation);
  }

  disconnectedCallback() {
    this.removeEventListener('keydown', this.stopEscapePropagation);
    super.disconnectedCallback();
  }

  stopEscapePropagation = (event) => {
    if (event.key === 'Escape') event.stopPropagation();
  };
}

if (!customElements.get('custom-size-guide')) customElements.define('custom-size-guide', CustomSizeGuide);
